import PresetCategories from './preset-categories';

export default {
  buildingBlocks(args = {}) {
    return PresetCategories.presetCategories(args);
  },
};
